import { z } from 'zod';

const nonNegativeInt = z.number().int().nonnegative();

export const inventoryTransferCountsSchema = z.object({
  scheduled: nonNegativeInt,
  suggested: nonNegativeInt,
});

export const inventorySidebarMetadataSchema = z.object({
  inventoryTransfer: inventoryTransferCountsSchema,
  inventoryReplenishment: nonNegativeInt,
});

export const sidebarMetadataSchema = z.object({
  inventory: inventorySidebarMetadataSchema,
});

export type SidebarMetadata = z.infer<typeof sidebarMetadataSchema>;
export type InventorySidebarMetadata = z.infer<typeof inventorySidebarMetadataSchema>;
